import TooltipContainer from "../../../Component/Ui-Kits/Tooltip/Tooltip"

const Tooltip = () => {
  return (
    <div className='page-body'>
      <TooltipContainer />
    </div>
  )
}

export default Tooltip